import { getPaymentLink, processPayment } from "@/api/hc360-payment.js";

const payment = {
  namespaced: true,

  state: () => ({
    Loading: false,
    getPaymentLinkData: null,
    processPaymentData: null,
  }),

  //   getters: {
  //     getState: (state) => {
  //       return state.stateName;
  //     },
  //   },

  actions: {
    getPaymentLink({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        getPaymentLink(payload)
          .then((api_data) => {
            state.getPaymentLinkData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            console.log("getPaymentLink store err", err);
          });
      });
    },

    processPayment({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        processPayment(payload)
          .then((api_data) => {
            state.processPaymentData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            console.log("processPayment store err", err);
          });
      });
    },
  },

  mutations: {
    TOGGLE_LOADING: (state) => {
      state.Loading = !state.Loading;
    },
  },
};

export default payment;
